import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { FirebaseService, TOTPInfo } from 'src/app/services/firebase.service';
import { RecaptchaVerifier } from 'firebase/auth';

@Component({
  selector: 'app-two-factor-enrollment',
  templateUrl: './two-factor-enrollment.component.html',
  styleUrls: ['./two-factor-enrollment.component.scss'],
})
export class TwoFactorEnrollmentComponent {
  @Output() signOut = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  @ViewChild('totpQRCanvas') totpQRCanvas?: ElementRef<HTMLDivElement>;

  successMessage = '';
  error = '';

  showTOTPSetup = false;
  totpInfo?: TOTPInfo | undefined;
  totpCode = '';
  verifyingTOTP = false;

  showSMSSetup = false;
  sendingSMS = false;
  verifyingSMS = false;
  smsSent = false;
  phoneNumber = '';
  smsVerificationId = '';
  smsCode = '';

  constructor(private firebaseService: FirebaseService) {}

  setupTOTP2FA() {
    console.log('two-factor-enrollment.component -> setupTOTP2FA');
    console.log('Setting up TOTP 2FA');
    this.showTOTPSetup = true;
    this.firebaseService.generateTOTPInfo().subscribe({
      next: (res) => {
        console.log('TOTP Info: ', res);
        this.totpInfo = res;
        this.error = '';
      },
      error: (err) => {
        console.error(err);
        if (
          err.code === 'auth/requires-recent-login' ||
          err.code === 'auth/user-token-expired'
        ) {
          // user needs to reauthenticate, logout and redirect to login
          this.signOut.emit();
        } else {
          this.error = 'Unexpected error occurred. Please try again.';
        }
      },
    });
  }

  verifyTOTPForEnrollment(code: string) {
    console.log('two-factor-enrollment.component -> verifyTOTPForEnrollment');

    if (!this.totpInfo) {
      console.error(new Error('TOTP info missing'));
      this.error = 'TOTP info missing';
      return;
    }

    this.verifyingTOTP = true;
    this.firebaseService
      .verifyTOTPCodeForEnrollment(this.totpInfo.secret, code)
      .subscribe({
        next: (res) => {
          console.log(`TOTP code verified`);
          this.verifyingTOTP = false;
          this.successMessage = '2FA enrollment successful';
          this.error = '';
          this.success.emit();
        },
        error: (err) => {
          console.error(err);
          this.verifyingTOTP = false;
          this.error = 'Error verifying TOTP code. Please try again.';
        },
      });
  }

  setupSMS2FA() {
    this.showSMSSetup = true;
  }

  sendSMSForEnrollment(info: {
    phoneNumber: string;
    recaptchaVerifier: RecaptchaVerifier;
  }) {
    console.log('two-factor-enrollment.component -> sendSMSForEnrollment');

    this.sendingSMS = true;
    this.smsSent = false;
    this.error = '';

    this.firebaseService
      .sendSMSForEnrollment(info.phoneNumber, info.recaptchaVerifier)
      .subscribe({
        next: (verificationId) => {
          this.sendingSMS = false;
          console.log('SMS sent: ', verificationId);
          this.smsVerificationId = verificationId;
          this.smsSent = true;
          this.error = '';
        },
        error: (err) => {
          this.sendingSMS = false;
          console.error(err);
          this.error = 'Error sending SMS. Please try again.';
        },
      });
  }

  verifySMSCodeForEnrollment(code: string) {
    console.log(
      'two-factor-enrollment.component -> verifySMSCodeForEnrollment'
    );

    if (!this.smsVerificationId) {
      console.error(new Error('SMS verification ID missing'));
      this.error = 'SMS verification ID missing';
      return;
    }

    this.verifyingSMS = true;
    this.firebaseService
      .verifySMSCodeForEnrollment(this.smsVerificationId, code)
      .subscribe({
        next: () => {
          console.log(
            `two-factor-enrollment.component -> verifySMSCodeForEnrollment -> SMS code verified`
          );
          this.verifyingSMS = false;
          this.successMessage = '2FA enrollment successful';
          this.error = '';
          this.success.emit();
        },
        error: (err) => {
          console.error(err);
          this.verifyingSMS = false;
          this.error = 'Error verifying SMS code. Please try again.';
        },
      });
  }

  goBackTo2FAChoices() {
    console.log('Going back to 2FA choices');
    this.showTOTPSetup = false;
    this.showSMSSetup = false;
    this.smsSent = false;
    this.error = '';
  }

  goBackToSendSMS() {
    this.smsSent = false;
    this.error = '';
  }
}
